import { apiClient } from "helpers/api_helper"

export const GetAllWalkInSourceData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetAllWalkInSourceGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllWalkInSourceForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetWalkInSourceSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getWalkInSourceDetailsById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetWalkInSourceDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createWalkInSource = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/customer/InsertWalkInSource', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateWalkInSource = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/customer/UpdateWalkInSource', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteWalkInSource = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/customer/DeleteWalkInSource?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};